// Match aistudio's existing top-level routes exactly
// (`/ai-agent/monitor/calibration/create-run`, `/ai-agent/monitor/calibration/:id`).
// The federation host slices its basePath off the URL and hands the remainder
// straight to this app's router (see `useFederatedRemote.js` on the aistudio
// side) — these paths must line up with aistudio's route table or a deep link
// 404s inside the remote's own router.
export const ROUTES = {
  HOME: '/',
  NEW_RUN: '/create-run',
  RUN_DETAIL: '/$runId',
} as const;

export const API_BASE = '/api/resources/observation-run';

// DM bot proxy. Backs the environment-promotion ladder (`GET /bot/environments`)
// that EP (`DYNAMIC_ENV`) bots drive the Calibration environment axis from.
export const BOT_API_BASE = '/api/resources/bot';

// DS metric-builder proxy (custom-metric validation pipeline).
export const METRIC_BUILDER_BASE = '/api/resources/metric-builder';
